'use client'

import { ChangeEvent, ReactNode, useState } from 'react';

type radioButtonType = {
  name: string;
  value: string;
  label: ReactNode;
  checked: boolean;
  onRadioChange: (e: string) => void
};
export function RadioButton({ name, value, label, onRadioChange, checked = false }: radioButtonType) {

  const [radioValue, setRadioValue] = useState(checked);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {

    setRadioValue(!checked);
    onRadioChange(e?.target?.value)
  };

  return (
    <div>
      <input
        checked={radioValue}
        id={`radio-id-${value}`}
        className={'btn lt-radio-btn'}
        type={'radio'}
        name={name}
        value={value}
        onChange={onChange}
      />
      <label htmlFor={`radio-id-${value}`}>{label}</label>
    </div>
  );
}
